import { Actions } from './templates.actions'
import { fromJS } from 'immutable'
import * as templatesTypes from './templates.types'

export const initialState = fromJS({
  tags: {
    isLoading: false,
    shouldReload: false,
    data: [],
  },
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 20,
    },
    total: 0,
    results: 0,
  },
  createTemplate: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateTemplate: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },

  testTemplate: {
    isLoading: false,
    validationErrors: {},
    data: null,
  },
})

export function templatesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case templatesTypes.UPDATE_TEMPLATE_REQUEST: {
      return state.setIn(['updateTemplate', 'isLoading'], true)
    }

    case templatesTypes.UPDATE_TEMPLATE_SUCCESS: {
      return state.setIn(['updateTemplate', 'isLoading'], false)
    }

    case templatesTypes.UPDATE_TEMPLATE_FAILURE: {
      return state.setIn(['updateTemplate', 'isLoading'], false)
    }

    case templatesTypes.CREATE_TEMPLATE_REQUEST: {
      return state.setIn(['createTemplate', 'isLoading'], true)
    }

    case templatesTypes.CREATE_TEMPLATE_SUCCESS: {
      return state.setIn(['createTemplate', 'isLoading'], false)
    }

    case templatesTypes.CREATE_TEMPLATE_FAILURE: {
      return state.setIn(['createTemplate', 'isLoading'], false)
    }

    case templatesTypes.DELETE_TEMPLATE_REQUEST: {
      return state
    }

    case templatesTypes.DELETE_TEMPLATE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case templatesTypes.DELETE_TEMPLATE_FAILURE: {
      return state
    }

    case templatesTypes.FETCH_TEMPLATES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case templatesTypes.FETCH_TEMPLATES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case templatesTypes.FETCH_TEMPLATES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case templatesTypes.FETCH_TEMPLATE_REQUEST: {
      return state.setIn(['updateTemplate', 'isLoading'], true)
    }

    case templatesTypes.FETCH_TEMPLATE_SUCCESS: {
      return state
        .setIn(['updateTemplate', 'isLoading'], false)
        .setIn(['updateTemplate', 'data'], fromJS(action.payload))
    }

    case templatesTypes.FETCH_TEMPLATE_FAILURE: {
      return state.setIn(['updateTemplate', 'isLoading'], false)
    }

    case templatesTypes.FETCH_TEMPLATE_TAGS_REQUEST: {
      return state.setIn(['tags', 'isLoading'], true)
    }

    case templatesTypes.FETCH_TEMPLATE_TAGS_SUCCESS: {
      return state
        .setIn(['tags', 'isLoading'], false)
        .setIn(['tags', 'data'], fromJS(action.payload))
    }

    case templatesTypes.FETCH_TEMPLATE_TAGS_FAILURE: {
      return state.setIn(['tags', 'isLoading'], false)
    }

    case templatesTypes.FETCH_TEST_TEMPLATE_REQUEST: {
      return state.setIn(['testTemplate', 'isLoading'], true)
    }

    case templatesTypes.FETCH_TEST_TEMPLATE_SUCCESS: {
      return state
        .setIn(['testTemplate', 'isLoading'], false)
        .setIn(['testTemplate', 'data'], action.payload)
    }

    case templatesTypes.FETCH_TEST_TEMPLATE_FAILURE: {
      return state.setIn(['testTemplate', 'isLoading'], false)
    }

    case templatesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case templatesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
